"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
function ButtonGroup(_a) {
    var options = _a.options, onClick = _a.onClick, value = _a.value, className = _a.className;
    var itemWidth = (0, react_1.useMemo)(function () { return (options ? 100 / options.length : 0); }, [options]);
    if (!options)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(className) }, options.map(function (valueItem) { return (react_1.default.createElement("div", { style: { flex: "1 1 ".concat(itemWidth, "%") }, className: "".concat(styles_module_scss_1.default.item, " ").concat(Number(value) === Number(valueItem.value) ? styles_module_scss_1.default.active : ''), key: "".concat(valueItem.value, "_").concat(valueItem.label), onClick: function () { return onClick && onClick(Number(valueItem.value)); } },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.label },
            react_1.default.createElement("span", null, valueItem.label)))); })));
}
exports.default = react_1.default.memo(ButtonGroup);
